import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";

export const Sheet = DialogPrimitive.Root;
export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;
export const SheetPortal = DialogPrimitive.Portal;

export const SheetOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn("fixed inset-0 z-50 bg-black/40 backdrop-blur-[2px] data-[state=open]:animate-fade-in", className)}
    {...props}
  />
));
SheetOverlay.displayName = "SheetOverlay";

const SIDE_CLASSES = {
  left: "inset-y-0 left-0 h-full w-72 border-r data-[state=open]:animate-slide-in-left data-[state=closed]:animate-slide-out-left",
  right: "inset-y-0 right-0 h-full w-72 border-l data-[state=open]:animate-slide-in-right data-[state=closed]:animate-slide-out-right",
};

export const SheetContent = React.forwardRef(({ className, side = "left", children, ...props }, ref) => (
  <SheetPortal>
    <SheetOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "fixed z-50 flex flex-col border-border bg-primary p-0 shadow-2xl focus:outline-none",
        SIDE_CLASSES[side],
        className
      )}
      {...props}
    >
      {children}
      <DialogPrimitive.Close
        className="absolute right-3 top-3.5 rounded-sm text-white/70 transition-colors hover:text-white focus:outline-none"
        data-testid="mobile-nav-close-button"
      >
        <X size={18} strokeWidth={1.5} />
        <span className="sr-only">Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </SheetPortal>
));
SheetContent.displayName = "SheetContent";

export const SheetTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title ref={ref} className={cn("font-heading text-lg font-semibold text-white", className)} {...props} />
));
SheetTitle.displayName = "SheetTitle";
